import AdminAxios from '../../utils/axios';

const getUsersAPI = (filters) => AdminAxios.get(`/user?${Object.keys(filters).map((f) => (filters[f] ? `${f}=${filters[f]}` : '')).join('&')}`);
const deleteUserAPI = (id) => AdminAxios.delete(`/user/${id}`);

export {
  getUsersAPI,
  deleteUserAPI,
};
